<template>
	<div
		class="rounded-xl px-4 lg:px-4 pt-2 pb-4 lg:pb-4 shadow"
		:class="[
			showMatching ? 'ring-2' : '',
			offer.trade == 'SELL' ? 'ring-green-500' : 'ring-orange-500',
			(offer.visible || (!offer.visible && offer.trade == 'BUY')) &&
			!offerIsExpired &&
			!commodityIsExpired &&
			!offerHasNoQty &&
			!invisibleNoPriceticker
				? 'bg-white'
				: 'bg-gray-200',
		]"
	>
		<ui-modal
			ref="deleteModal"
			:small="true"
			:confirm-label="__('Delete')"
			v-on:confirm="deleteOffer()"
			v-on:dismiss="showDeleteModal = false"
			v-on:close="showDeleteModal = false"
			v-if="showDeleteModal"
			>{{ __("Do you want to delete the listing?") }}</ui-modal
		>

		<!-- circle or square MOBILE -->
		<div
			class="flex sm:hidden mt-2"
			:class="offer.trade == 'SELL' && !offer.visible ? 'opacity-50' : ''"
		>
			<div
				v-if="offer.trade == 'SELL'"
				class="mr-2 flex-shrink-0 inline-block align-text-bottom sm:border-2 bg-green-500 sm:bg-transparent sm:border-green-500 rounded-full w-4 h-4"
			></div>
			<div
				v-else
				class="mr-2 flex-shrink-0 inline-block align-text-bottom sm:border-2 bg-orange-500 sm:bg-transparent sm:border-orange-500 w-4 h-4"
			></div>
			<div
				class="font-medium text-xs whitespace-nowrap"
				:class="offer.trade == 'SELL' ? 'text-green-500' : 'text-orange-500'"
			>
				{{ offer.trade == "BUY" ? __("My buy offer") : __("My sell offer") }}
			</div>
		</div>

		<div class="flex">
			<!-- icon DESKTOP-->
			<div class="hidden sm:block self-center flex-shrink-0 mt-2 mr-6">
				<div
					class="h-[5.5rem] w-[5.5rem] pt-1 px-2 pb-2 border-2 relative"
					:class="[
						offer.trade == 'SELL'
							? 'rounded-full border-green-500'
							: 'border-orange-500',
						offer.trade == 'SELL' && !offer.visible ? 'opacity-50' : '',
					]"
				>
					<ui-icon
						:name="offer.product.type.toLowerCase()"
						fill="currentColor"
						:class="[
							offer.trade == 'BUY' ? 'text-orange-500' : 'text-green-500',
						]"
						stroke-width="2.5"
					/>
					<div
						class="h-[5.5rem] w-[5.5rem] px-1 -rotate-90 absolute inset-0 text-xs"
						v-if="offer.trade == 'BUY' && !offer.visible"
					>
						<div
							class="bg-orange text-white text-center absolute bottom-0 -right-0.5 mb-1 w-full"
						>
							Nur Preisticker
						</div>
					</div>
				</div>
				<div
					class="mt-1 text-xs text-center whitespace-nowrap"
					:class="[
						offer.trade == 'SELL' ? 'text-green-500' : 'text-orange-500',
						offer.trade == 'SELL' && !offer.visible ? 'opacity-50' : '',
					]"
				>
					{{ offer.trade == "BUY" ? __("My buy offer") : __("My sell offer") }}
				</div>
			</div>

			<!-- md:flex bg-orange-500 -->
			<!-- grid-flow-col -->
			<div
				class="flex-grow md:grid grid-cols-6"
				:class="
					offer.price_indications_count > 0 && showPriceIndication
						? 'grid-rows-4 xl:grid-rows-3'
						: 'grid-rows-3 xl:grid-rows-2'
				"
			>
				<!-- offer info/data -->
				<!-- flex-grow -->
				<div class="md:row-span-3 xl:row-span-4 md:col-span-5 xl:col-span-4">
					<!-- Title row -->
					<div
						class="md:order-1 md:col-span-9 font-semibold text-2xl my-2 flex flex-wrap md:grid md:grid-cols-9 gap-x-2 md:gap-y-1"
					>
						<span class="" :class="['text-gray-500']">{{
							offer.product.origin
						}}</span>
						<span class="col-span-8" :class="['text-gray-900']"
							>{{ productArticle }}, {{ __("Harvest") }}
							{{ offer.product.harvest || __("n.a.") }}</span
						>
					</div>

					<!-- Product info grid -->
					<div
						class="md:order-3 md:col-span-12 my-2 md:grid md:grid-cols-9 gap-x-2 gap-y-1"
					>
						<!-- quantity -->
						<div
							class="order-1 col-span-4 grid grid-cols-4 md:grid-cols-4 gap-x-2"
						>
							<div :class="['text-gray-500']">{{ __("Quantity") }}:</div>
							<div class="col-span-3" :class="['text-gray-900']">
								{{ offer.qty.mt }} t
							</div>
						</div>

						<!-- price -->
						<div
							class="order-3 col-span-4 grid grid-cols-4 md:grid-cols-4 gap-x-2"
						>
							<div :class="['text-gray-500']">{{ __("Price") }}:</div>
							<div class="col-span-3 lg:col-span-2" :class="['text-gray-900']">
								<span v-if="offer.price.mt" class="">
									{{ $cropOptions.formatLocalizedNumber(offer.price.mt) }} €/t

									<ui-tooltip
										class="text-sm xl:text-base font-normal ml-1"
										v-if="offer.price.type == 'INDEXED'"
									>
										<template v-slot:label>
											<span
												class="inline-block px-2 py-0.5 text-xs font-medium rounded-full"
												:class="
													offer.trade == 'SELL'
														? 'text-green-500 bg-green-50'
														: 'text-orange-500 bg-orange-50'
												"
											>
												{{ __("Premium") }}
											</span>
											<!-- <span class="inline-block px-2 py-0.5 text-xs font-medium rounded-full bg-gray-500 text-gray-200">
                                                {{ __('Premium')}}
                                            </span> -->
										</template>
										<template v-slot:content>
											Basis {{ offer.price.basis }} €/t
											<span v-if="offer.commodityFuture">
												{{ offer.price.basis > 0 ? __("above") : __("below") }}
												{{ offer.commodityFuture.name }}
											</span>
										</template>
									</ui-tooltip>
								</span>
								<span v-else>{{ __("n.a.") }}</span>
							</div>
						</div>

						<!-- location -->
						<div
							class="order-2 md:col-span-5 grid grid-cols-4 md:grid-cols-5 flex gap-x-2"
						>
							<div :class="['text-gray-500']">{{ __("Location") }}:</div>
							<div
								class="col-span-3 lg:col-span-4 flex gap-x-2 flex-wrap"
								:class="['text-gray-700']"
							>
								<!-- {{ options.locationToString(offer) }} -->
								<span>{{
									$cropOptions.getLocalizedLabel(
										offer.location.mode,
										$cropOptions.locationModeOptions
									)
								}}</span>
								<span>
									{{ offer.location.address.zip }}
									{{ offer.location.address.city }}
								</span>
							</div>
						</div>

						<!-- date -->
						<div
							class="order-4 md:col-span-5 grid grid-cols-4 md:grid-cols-5 gap-x-2"
						>
							<div :class="['text-gray-500']">{{ __("Fulfilment Date") }}:</div>
							<div class="col-span-3 lg:col-span-4" :class="['text-gray-700']">
								{{ $cropOptions.dateToString(offer, locale, true) }}
							</div>
						</div>
					</div>
				</div>

				<!-- action icons 1 -->
				<!--  -->
				<div
					class="md:row-span-2 xl:col-span-2 text-orange-500 min-h-[2.5rem] flex md:flex-col items-center md:items-end justify-between items-end"
					v-if="showActionButtons"
				>
					<div class="flex -ml-2 sm:ml-0 sm:justify-end min-w-[7.5rem]">
						<div
							v-if="offer.trade == 'SELL' && !offer.visible && !offerHasErrors"
							class="flex space-x-2 mr-auto p-2 lg:ml-auto"
						>
							<span class="text-red-500 font-semibold whitespace-nowrap">{{
								__("not visible")
							}}</span>
							<ui-tooltip class="font-normal" :text="__('make visible')">
								<template v-slot:label>
									<ui-toggle
										class="!bg-red-500"
										:value="false"
										v-on:change="toggleOfferVisibility()"
									/>
								</template>
							</ui-tooltip>
						</div>
						<ui-tooltip
							v-if="
								offer.trade == 'BUY' ||
								offer.visible ||
								(offer.trade == 'SELL' && offerHasErrors)
							"
							class="font-normal"
							:text="__('Use as template')"
						>
							<template v-slot:label>
								<button
									class="ml-auto hover:bg-gray-100 rounded-lg p-2"
									:class="['text-orange-500']"
									v-on:click="
										$bus.$emit(
											'toggle-iframe-modal',
											$route('offers' + '.create') +
												'?iframe_modal=true&copy_from=' +
												offer.id +
												'&trade=' +
												offer.trade
										)
									"
								>
									<ui-icon class="h-5 w-5" name="copy" stroke-width="2.5" />
								</button>
							</template>
						</ui-tooltip>

						<ui-tooltip
							v-if="
								(!offerHasAuction || !auctionIsActive) &&
								(offer.trade == 'BUY' ||
									offer.visible ||
									(offer.trade == 'SELL' && offerHasErrors))
							"
							class="font-normal"
							:text="__('Edit Offer')"
						>
							<template v-slot:label>
								<button
									class="hover:bg-gray-100 rounded-lg p-2"
									:class="['text-orange-500']"
									v-on:click="
										$bus.$emit(
											'toggle-iframe-modal',
											$route('offers_' + offer.trade.toLowerCase() + '.edit', {
												id: offer.id,
											})
										)
									"
								>
									<ui-icon class="h-5 w-5" name="edit" stroke-width="2.5" />
								</button>
							</template>
						</ui-tooltip>

						<ui-tooltip
							v-if="
								(!offerHasAuction || !auctionIsActive) &&
								(offer.trade == 'BUY' ||
									offer.visible ||
									(offer.trade == 'SELL' && offerHasErrors))
							"
							class="font-normal"
							:text="__('Delete Offer')"
						>
							<template v-slot:label>
								<button
									v-on:click="showDeleteModal = true"
									class="hover:bg-gray-100 rounded-lg p-2"
									:class="['text-orange-500']"
								>
									<ui-icon class="h-5 w-5" name="trash" stroke-width="2.5" />
								</button>
							</template>
						</ui-tooltip>
					</div>

					<div
						v-if="
							offer.trade == 'BUY' &&
							!offer.visible &&
							offer.location.mode == 'DAP' &&
							offer.location.optional_transport &&
							!offerIsExpired &&
							!commodityIsExpired &&
							!offerHasNoQty
						"
						class="md:text-right mt-3 md:mt-0"
					>
						<span class="text-gray-500 font-semibold">
							{{ __("only_visible_on_cropspot_price_ticker_1") }}<br />
							{{ __("only_visible_on_cropspot_price_ticker_2") }}
						</span>
					</div>
					<page-link
						:href="
							$route('bid.createBulk', {
								sourceType: offer.trade,
								sourceId: offer.id,
							})
						"
						v-if="
							offer.trade == 'BUY' &&
							offer.visible &&
							offer.newMatchesCount > 0 &&
							!offerIsExpired &&
							!commodityIsExpired &&
							!offerHasNoQty
						"
						:class="bulkBidButtonClass"
						>{{ offer.newMatchesCount }} {{ __("matches") }}</page-link
					>
					<ui-button
						:type="matchesButtonType"
						:disabled="offerHasErrors"
						v-else-if="
							offer.trade !== 'BUY' &&
							offer.newMatchesCount > 0 &&
							!showMatchingOffers &&
							offer.visible
						"
						v-on:click="offer.newMatchesCount > 0 ? getMatches() : null"
						class="ml-auto flex gap-x-2 whitespace-nowrap items-center xl:mb-4"
						:class="
							user.acl__auction_edit
								? 'xl:mb-4 truncate bg-white-500 text-orange px-4 py-1.5 font-medium rounded-lg border-orange ring-2 ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 hover:text-white focus:outline-none font-medium'
								: ''
						"
					>
						<!-- <ui-icon class="h-5 w-5" name="bell" stroke-width="2.5" />  -->
						{{ offer.newMatchesCount }} {{ __("matches") }}
					</ui-button>
					<button
						v-if="offer.newMatchesCount > 0 && showMatchingOffers"
						v-on:click="offer.newMatchesCount > 0 ? getMatches() : null"
						class="hover:bg-gray-100 rounded-lg p-2 ml-auto font-semibold underline text-orange-500 text-lg flex gap-x-2 whitespace-nowrap items-center"
					>
						<ui-icon
							class="hidden md:block h-5 w-5"
							name="x"
							stroke-width="2.5"
						/>
					</button>
				</div>

				<!-- live price button -->
				<div
					v-if="offer.trade == 'BUY' && showPriceIndication"
					class="md:col-span-6 flex-none md:flex justify-between"
				>
					<div
						v-if="
							priceIndicationStat && offer.priceindication.status == 'ACTIVE'
						"
					>
						<span class="font-semibold whitespace-nowrap text-green-500"
							>{{ priceIndicationStat.sum_indications }}
							{{ __("farmers reached") }}</span
						>
						<span
							v-if="bestPricePercentage < 20"
							class="font-semibold whitespace-nowrap ml-4"
							:class="'text-red-500'"
							>nur bei {{ bestPricePercentage }}% Bestpreis</span
						>
					</div>
					<div v-else class="font-semibold py-2">
						<div
							v-if="
								offer.visible &&
								(offer.location.mode !== 'DAP' ||
									!offer.location.optional_transport)
							"
							class="text-red-500"
						>
							{{ __("only_dap_offers_can_be_displayed_in_price_ticker") }}
						</div>
						<div v-else-if="offerIsExpired" class="text-red-500">
							{{ __("offer_request_date_is_expired") }}
						</div>
						<div v-else-if="commodityIsExpired" class="text-red-500">
							{{ __("commodity_future_is_expired") }}
						</div>
						<div v-else-if="offerHasNoQty" class="text-red-500">
							{{ __("offer_qty_is_zero") }}
						</div>
						<div
							v-else-if="priceIndicationInProgress"
							class="text-green-500 flex justify-start"
						>
							<ui-icon
								:class="[
									'mr-4 md:mr-3 flex-shrink-0 h-7 w-7 text-2xl animate-spin',
								]"
								name="fa-spinner"
								stroke-width="2"
							/>
							{{ __("price_calculation_in_progress") }}
						</div>
						<div v-else class="text-red-500">
							{{ __("cannot_be_displayed_in_price_ticker") }}
						</div>
					</div>
					<div class="block md:text-right mt-3 md:mt-0">
						<ui-button
							:type="
								priceIndicationInProgress ||
								offerHasErrors ||
								!(
									offer.location.mode == 'DAP' &&
									offer.location.optional_transport
								)
									? 'primary-disabled'
									: 'primary'
							"
							:disabled="priceIndicationInProgress"
							v-if="
								(offer.priceindication.status == 'ACTIVE' && !showInlineEdit) ||
								priceIndicationInProgress ||
								offerHasErrors ||
								!(
									offer.location.mode == 'DAP' &&
									offer.location.optional_transport
								)
							"
							v-on:click="
								!priceIndicationInProgress &&
								!offerHasErrors &&
								offer.location.mode == 'DAP' &&
								offer.location.optional_transport
									? updateOffer()
									: null
							"
						>
							{{ __("edit_daily_price") }}
						</ui-button>
						<ui-button
							type="primary"
							v-else-if="!showInlineEdit && !offerHasErrors"
							v-on:click="updateOffer()"
							:disabled="!piShowButton"
						>
							{{ __("create_daily_price") }}
						</ui-button>
						<button
							v-if="showInlineEdit"
							v-on:click="updateOffer()"
							class="hover:bg-gray-100 rounded-lg p-2 ml-auto font-semibold underline text-orange-500 text-lg flex gap-x-2 whitespace-nowrap items-center"
						>
							<ui-icon class="block h-5 w-5" name="x" stroke-width="2.5" />
						</button>
					</div>
				</div>
				<!-- div
					v-else-if="offer.trade == 'BUY' && user.acl__price_indication_edit"
					class="md:col-span-6 flex-none md:flex justify-between"
				>
					<div
						v-if="
							offer.visible &&
							(offer.location.mode !== 'DAP' ||
								!offer.location.optional_transport)
						"
						class="text-red-500 font-semibold py-2"
					>
						{{ __("only_dap_offers_can_be_displayed_in_price_ticker") }}
					</div>
					<div v-else class="text-red-500 font-semibold py-2">
						<div v-if="offerIsExpired">
							{{ __("offer_request_date_is_expired") }}
						</div>
						<div v-else-if="commodityIsExpired">
							{{ __("commodity_future_is_expired") }}
						</div>
						<div v-else-if="offerHasNoQty">
							{{ __("offer_qty_is_zero") }}
						</div>
						<div
							v-else-if="priceIndicationInProgress"
							class="text-green-500 flex justify-start"
						>
							<ui-icon
								:class="[
									'mr-4 md:mr-3 flex-shrink-0 h-7 w-7 text-2xl animate-spin',
								]"
								name="fa-spinner"
								stroke-width="2"
							/>
							{{ __("price_calculation_in_progress") }}
						</div>
						<div v-else>
							{{ __("cannot_be_displayed_in_price_ticker") }}
						</div>
					</div>
					<ui-button
						type="primary"
						v-if="
							!offerHasErrors &&
							!showInlineEdit &&
							offer.location.mode == 'DAP' &&
							offer.location.optional_transport
						"
						v-on:click="updateOffer()"
					>
						{{ __("create_daily_price") }}
					</ui-button>
					<div
						v-else-if="!showInlineEdit"
						class="block md:text-right md:col-span-6 xl:col-span-2"
					>
						<ui-button type="primary-disabled" :disabled="true">
							{{ __("create_daily_price") }}
						</ui-button>
					</div>
					<button
						v-if="showInlineEdit"
						v-on:click="updateOffer()"
						class="hover:bg-gray-100 rounded-lg p-2 ml-auto font-semibold underline text-orange-500 text-lg flex gap-x-2 whitespace-nowrap items-center"
					>
						<ui-icon class="block h-5 w-5" name="x" stroke-width="2.5" />
					</button>
				</div -->
				<div
					v-else-if="
						(offer.trade == 'BUY' && !user.acl__price_indication_edit) ||
						offer.trade == 'SELL'
					"
					class="md:col-span-6 flex justify-between"
				>
					<div v-if="offerIsExpired" class="text-red-500 font-semibold">
						{{ __("offer_request_date_is_expired") }}
					</div>
					<div
						v-else-if="commodityIsExpired"
						class="text-red-500 font-semibold"
					>
						{{ __("commodity_future_is_expired") }}
					</div>
					<div v-else-if="offerHasNoQty" class="text-red-500 font-semibold">
						{{ __("offer_qty_is_zero") }}
					</div>
					<div
						v-if="
							offer.trade == 'SELL' &&
							user.acl__auction_edit &&
							!showAuctionEdit &&
							offer.location.mode == 'FCA' &&
							!offerHasErrors
						"
						class="font-semibold mt-2 flex"
					>
						<ui-icon
							class="h-5 w-5 text-orange-500"
							name="fa-arrow-right"
							stroke-width="2.5"
						/>
						<a
							href="#"
							class="text-orange-500 underline ml-2"
							@click="showAuctionInfoModal = true"
							>{{ __("mehr über die neue Auktion auf cropspot erfahren") }}</a
						>
					</div>
					<div
						v-if="
							auction !== null &&
							offer.trade == 'SELL' &&
							user.acl__auction_edit &&
							!showAuctionEdit &&
							offer.location.mode !== 'FCA' &&
							!offerHasErrors
						"
						class="text-red-500 font-semibold mt-2"
					>
						{{
							__(
								"Dieses Inserat kann aufgrund der Parität nicht über die Auktion angeboten werden."
							)
						}}
					</div>
					<div
						v-if="
							auction !== null &&
							offer.trade == 'SELL' &&
							user.acl__auction_edit &&
							offerHasAuction &&
							!showAuctionEdit
						"
						class="font-semibold text-xl"
					>
						<img :src="auctionHammerUrl" class="inline" />
						{{ offer.auction.qty_mt }} t {{ __("in Auktion") }}
						<span class="font-normal text-sm"
							>({{ __("Ihr Zielpreis") }}
							{{ offer.auction.price }} &euro;/t)</span
						>
					</div>
					<div
						v-if="
							offer.trade == 'SELL' &&
							user.acl__auction_edit &&
							auction !== null
						"
						class="block md:text-right mt-3 md:mt-0"
					>
						<ui-button
							:type="
								offer.location.mode !== 'FCA' ||
								offerHasErrors ||
								auctionMyLotsState !== 'INTAKE'
									? 'primary-disabled'
									: 'primary'
							"
							:disabled="
								offer.location.mode !== 'FCA' ||
								offerHasErrors ||
								auctionMyLotsState !== 'INTAKE'
							"
							v-on:click="updateAuction()"
							v-if="!showAuctionEdit && offerHasAuction"
						>
							{{ __("Auktionsmenge anpassen") }}
						</ui-button>
						<ui-button
							:type="
								offer.location.mode !== 'FCA' ||
								offerHasErrors ||
								auctionMyLotsState !== 'INTAKE'
									? 'primary-disabled'
									: 'primary'
							"
							:disabled="
								offer.location.mode !== 'FCA' ||
								offerHasErrors ||
								auctionMyLotsState !== 'INTAKE'
							"
							v-on:click="updateAuction()"
							v-else-if="!showAuctionEdit"
						>
							{{ __("Auktionsmenge bereitstellen") }}
						</ui-button>
					</div>
				</div>
			</div>
		</div>

		<!-- showMatchingOffers -->
		<my-lots-card-matches
			class="hidden md:block"
			v-if="showMatchingOffers"
			:offer="offer"
			:new-matches="newMatches"
			@close="showMatchingOffers = false"
		/>
		<my-lots-card-matches-mobile
			class="block md:hidden"
			v-if="showMatchingOffers"
			:offer="offer"
			:new-matches="newMatches"
			@close="showMatchingOffers = false"
		/>

		<my-lots-edit-offer-inline
			v-if="showInlineEdit"
			:offer="offer"
			:show-price-indication="showPriceIndication"
			:price-indication-stat="priceIndicationStat"
			:active-futures="activeFutures"
			:piEndOfDay="piEndOfDay"
			:piShowButton="piShowButton"
			:form="form"
		/>

		<my-lots-edit-auction-listing
			v-if="showAuctionEdit"
			:offer="offer"
			:active-futures="activeFutures"
			:form="form"
			:updateAuction="updateAuction"
			:auction="auction"
		/>

		<my-lots-auction-info-modal
			v-if="showAuctionInfoModal"
			v-on:close="showAuctionInfoModal = false"
		></my-lots-auction-info-modal>
	</div>
</template>

<script>
// let options = require("../../cropOptions");

export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		showActionButtons: {
			type: Boolean,
			default: true,
		},
		priceIndicationStat: {
			type: Object,
			required: false,
		},
		activeFutures: {
			type: Array,
			required: false,
		},
		auction: {
			type: Object,
			required: false,
			default: null,
		},
		auctionMyLotsState: {
			type: String,
			required: true,
		},
		piEndOfDay: {
			type: Boolean,
			required: false,
			default: false,
		},
		piShowButton: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data: function () {
		return {
			newMatches: null,
			showMatchingOffers: false,
			showMatchingCurrentNegotiations: false,
			showMatchingContracts: false,
			showOfferToggleVisibilityModal: false,
			user: this.$inertia.page.props.user,
			showDeleteModal: false,
			acl: this.$inertia.page.props.acl,
			showInlineEdit: false,
			form: Vue.observable(this.$inertia.form(this.offer)),
			showAuctionInfoModal: false,
			showAuctionEdit: false,
		};
	},
	computed: {
		offersUrl: function () {
			return (
				window.baseUrl + "/home/offers_" + this.offer.trade.toLowerCase() + "/"
			);
		},
		editUrl: function () {
			return this.offersUrl + this.offer.id + "/edit";
		},
		searchUrl() {
			return window.baseUrl + "/search";
		},
		bulkBidUrl() {
			return window.baseUrl + "/bulk_bid/create/offer_buy/" + this.offer.id;
		},
		cardTitle() {
			return this.offer.name
				? this.offer.name
				: this.__(
						this.$cropOptions.getLabel(
							this.offer.product.grade,
							this.$cropOptions.productGradeOptions
						)
				  );
		},
		iconFrame() {
			return this.offer.trade == "SELL" ? "text-green-500" : "text-orange-500";
		},

		canBulkBid() {
			return this.user && this.user.type != "FARMER";
		},
		offerTitle() {
			return this.offer.trade == "BUY"
				? this.__("Buy offer")
				: this.__("Sell offer");
		},
		productArticle() {
			if (
				this.offer.product.grade == "WHEAT_B__OTHER" &&
				this.offer.quality.protein_min !== ""
			) {
				return this.$cropOptions.getLocalizedWheatOtherLabel(
					this.offer.quality.protein_min
				);
			} else {
				return this.__(
					this.getLabel(
						this.offer.product.grade,
						this.$cropOptions.productGradeOptions
					) ||
						this.getLabel(
							this.offer.product.type,
							this.$cropOptions.productTypeOptions
						)
				);
			}
		},

		showMatching: function () {
			return (
				this.showMatchingOffers ||
				this.showMatchingCurrentNegotiations ||
				this.showMatchingContracts
			);
		},
		showPriceIndication() {
			return this.acl.can_priceindications_edit;
		},
		matchesButtonType() {
			return (this.offer.price_indications_count > 0 &&
				this.showPriceIndication) ||
				(this.offer.trade == "SELL" &&
					this.user.acl__auction_edit &&
					this.auction !== null &&
					this.auctionMyLotsState !== "DISABLED")
				? "primary-reverted"
				: (!this.user.acl__price_indication_edit && this.offerHasErrors) ||
				  (this.offer.trade == "SELL" && this.offerHasErrors)
				? "primary-disabled"
				: "primary";
		},
		bulkBidButtonClass() {
			return (this.offer.price_indications_count > 0 ||
				this.showPriceIndication ||
				this.offer.trade == "BUY") &&
				this.user.acl__price_indication_edit
				? "xl:mb-4 truncate bg-white-500 text-orange px-4 py-1.5 font-medium rounded-lg border-orange ring-2 ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 hover:text-white focus:outline-none font-medium"
				: !this.user.acl__price_indication_edit && this.offerHasErrors
				? "xl:mb-4 truncate bg-gray-300 rounded-lg py-1.5 px-4 font-medium text-white hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 hover:shadow-md disabled-link"
				: "xl:mb-4 truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 focus:outline-none font-medium";
		},
		offerHasErrors() {
			return (
				this.offerIsExpired || this.offerHasNoQty || this.commodityIsExpired
			);
		},
		bestPricePercentage() {
			return this.priceIndicationStat &&
				this.priceIndicationStat.sum_indications > 0
				? Math.ceil(
						(this.priceIndicationStat.sum_best_price /
							this.priceIndicationStat.sum_indications) *
							100
				  )
				: 0;
		},
		offerIsExpired() {
			if (!this.offer.date.month_to) {
				return false;
			} else {
				var monthTo = new Date(this.offer.date.month_to);
				var lastDayOfMonth = new Date(
					monthTo.getFullYear(),
					monthTo.getMonth() + 1,
					0
				);
				return lastDayOfMonth < new Date();
			}
		},
		offerHasNoQty() {
			if (!this.offer.qty.mt || this.offer.qty.mt <= 0) {
				return true;
			}
			return false;
		},
		commodityIsExpired() {
			if (this.offer.commodityFuture && this.offer.commodityFuture.expired) {
				return true;
			}
			return false;
		},
		currentDate() {
			let today = new Date();
			return today.toISOString().substr(0, 10);
		},
		priceIndicationInProgress() {
			if (
				this.offer.priceindication.status == "PENDING" ||
				this.offer.priceindication.status == "INPROGRESS"
			) {
				return true;
			}
			return false;
		},
		offerHasAuction() {
			if (this.offer.trade == "SELL" && this.offer.auction.qty_mt > 0) {
				return true;
			}
			return false;
		},
		auctionHammerUrl() {
			return window.baseUrl + "/images/auction-hammer.svg";
		},
		auctionIsActive() {
			if (this.auction !== null && this.auctionMyLotsState !== "INTAKE") {
				return true;
			}
			return false;
		},
		invisibleNoPriceticker() {
			if (
				this.offer.trade == "BUY" &&
				this.showPriceIndication &&
				!this.offer.visible
			) {
				if (
					!this.priceIndicationStat ||
					(this.offer.priceindication.status !== "ACTIVE" &&
						!this.priceIndicationInProgress)
				) {
					return true;
				}
			}
			return false;
		},
	},
	methods: {
		getLabel(what, where) {
			return this.$cropOptions.getLabel(what, where);
		},
		toggleOfferVisibility() {
			this.$inertia.patch(
				this.$route(
					"offers_" + this.offer.trade.toLowerCase() + ".toggleVisible",
					{
						id: this.offer.id,
					}
				)
			);
		},
		deleteOffer() {
			this.$inertia.delete(
				this.$route("offers_" + this.offer.trade.toLowerCase() + ".delete", {
					id: this.offer.id,
				})
			);
		},
		async getMatches() {
			if (!this.newMatches) {
				let trade = this.offer.trade.toLowerCase(),
					id = this.offer.id;

				let req = await axios.get(route("api.offers.get_matches", [trade, id]));
				this.offer.matches = req.data.matches;

				this.newMatches = this.offer.matches.results;
			}
			this.showMatchingOffers = !this.showMatchingOffers;
			if (this.showMatchingOffers && this.showAuctionEdit) {
				this.showAuctionEdit = false;
			}
		},
		updateOffer() {
			this.showInlineEdit = !this.showInlineEdit;
		},
		updateAuction() {
			this.showAuctionEdit = !this.showAuctionEdit;
			if (this.showMatchingOffers && this.showAuctionEdit) {
				this.showMatchingOffers = false;
			}
		},
	},
};
</script>
